import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

/**
 * Searchable single select for long option lists (hundreds of items), with
 * accent-insensitive filtering. Emits { target: { name, value } } so it plugs
 * into useForm.handleChange like a native <select>.
 */
const SearchableSelect = ({ id, name, value, options, onChange, placeholder, invalid, disabled, required }) => {
  const selected = useMemo(() => options.find((o) => o.value === value) || null, [options, value])
  return (
    <Select
      inputId={id}
      name={name}
      classNamePrefix="select2-selection"
      className={invalid ? 'is-invalid' : ''}
      options={options}
      value={selected}
      onChange={(opt) => onChange({ target: { name, value: opt ? opt.value : '' } })}
      isDisabled={disabled}
      isClearable
      isSearchable
      placeholder={placeholder || 'Selecione ou digite para buscar'}
      noOptionsMessage={() => 'Nenhuma opção encontrada'}
      filterOption={(opt, input) => norm(opt.label).includes(norm(input))}
      aria-required={required || undefined}
    />
  )
}

SearchableSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
}

export default SearchableSelect
